/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUmbrella = createReactComponent("umbrella", "IconUmbrella", [
  ["path", { d: "M4 12a8 8 0 0 1 16 0z", key: "svg-0" }],
  ["path", { d: "M12 12v6a2 2 0 0 0 4 0", key: "svg-1" }]
]);

export { IconUmbrella as default };
//# sourceMappingURL=IconUmbrella.js.map
